import React, { useState } from "react";
import Send_Button_Modal from "../common_components/common-modals/send-btn-modal/Send_Button_Modal";
import Call_Now_Modal from "../common_components/common-modals/call-now-modal/Call_Now_Modal";
import Common_Headings from "../common_components/common_heading/Common_Headings";
import Common_Vendor_Card from "../common_components/common-vendor-card/Common_Vendor_Card";
import Pagination_Holder from "../common_components/pagination-holder/Pagination_Holder";
import "./Vendors.css";

const vendors = [
  {
    id: 1,
    name: "Jay Hardware",
    location: "Katraj, Pune",
    material: "Hardware",
    description:
      "Quality Building Materials At The Best Price With Timely Delivery And Trusted Service.",
    image: "/assets/images/vendors/vendor1.png",
    verified: true,
  },
  {
    id: 2,
    name: "Vardhan Steel",
    location: "Bavdhan, Pune",
    material: "Steel",
    description:
      "Quality Building Materials At The Best Price With Timely Delivery And Trusted Service.",
    image: "/assets/images/vendors/vendor2.png",
    verified: true,
  },
  {
    id: 3,
    name: "Akash Plywoods",
    location: "Hadapsar, Pune",
    material: "Plywood",
    description:
      "Quality Building Materials At The Best Price With Timely Delivery And Trusted Service.",
    image: "/assets/images/vendors/vendor3.png",
    verified: true,
  },
  {
    id: 4,
    name: "Jay Hardware",
    location: "Katraj, Pune",
    material: "Hardware",
    description:
      "Quality Building Materials At The Best Price With Timely Delivery And Trusted Service.",
    image: "/assets/images/vendors/vendor1.png",
    verified: true,
  },
  {
    id: 5,
    name: "Vardhan Steel",
    location: "Bavdhan, Pune",
    material: "Steel",
    description:
      "Quality Building Materials At The Best Price With Timely Delivery And Trusted Service.",
    image: "/assets/images/vendors/vendor2.png",
    verified: true,
  },
  {
    id: 6,
    name: "Akash Plywoods",
    location: "Hadapsar, Pune",
    material: "Plywood",
    description:
      "Quality Building Materials At The Best Price With Timely Delivery And Trusted Service.",
    image: "/assets/images/vendors/vendor3.png",
    verified: true,
  },
  {
    id: 7,
    name: "Jay Hardware",
    location: "Katraj, Pune",
    material: "Hardware",
    description:
      "Quality Building Materials At The Best Price With Timely Delivery And Trusted Service.",
    image: "/assets/images/vendors/vendor1.png",
    verified: true,
  },
  {
    id: 8,
    name: "Vardhan Steel",
    location: "Bavdhan, Pune",
    material: "Steel",
    description:
      "Quality Building Materials At The Best Price With Timely Delivery And Trusted Service.",
    image: "/assets/images/vendors/vendor2.png",
    verified: true,
  },
  {
    id: 9,
    name: "Akash Plywoods",
    location: "Hadapsar, Pune",
    material: "Plywood",
    description:
      "Quality Building Materials At The Best Price With Timely Delivery And Trusted Service.",
    image: "/assets/images/vendors/vendor3.png",
    verified: true,
  },

  {
    id: 10,
    name: "Jay Hardware",
    location: "Katraj, Pune",
    material: "Hardware",
    description:
      "Quality Building Materials At The Best Price With Timely Delivery And Trusted Service.",
    image: "/assets/images/vendors/vendor1.png",
    verified: true,
  },
  {
    id: 11,
    name: "Vardhan Steel",
    location: "Bavdhan, Pune",
    material: "Steel",
    description:
      "Quality Building Materials At The Best Price With Timely Delivery And Trusted Service.",
    image: "/assets/images/vendors/vendor2.png",
    verified: true,
  },
  {
    id: 12,
    name: "Akash Plywoods",
    location: "Hadapsar, Pune",
    material: "Plywood",
    description:
      "Quality Building Materials At The Best Price With Timely Delivery And Trusted Service.",
    image: "/assets/images/vendors/vendor3.png",
    verified: true,
  },
  {
    id: 13,
    name: "Jay Hardware",
    location: "Katraj, Pune",
    material: "Hardware",
    description:
      "Quality Building Materials At The Best Price With Timely Delivery And Trusted Service.",
    image: "/assets/images/vendors/vendor1.png",
    verified: true,
  },
  {
    id: 14,
    name: "Vardhan Steel",
    location: "Bavdhan, Pune",
    material: "Steel",
    description:
      "Quality Building Materials At The Best Price With Timely Delivery And Trusted Service.",
    image: "/assets/images/vendors/vendor2.png",
    verified: true,
  },
  {
    id: 15,
    name: "Akash Plywoods",
    location: "Hadapsar, Pune",
    material: "Plywood",
    description:
      "Quality Building Materials At The Best Price With Timely Delivery And Trusted Service.",
    image: "/assets/images/vendors/vendor3.png",
    verified: true,
  },
  {
    id: 16,
    name: "Jay Hardware",
    location: "Katraj, Pune",
    material: "Hardware",
    description:
      "Quality Building Materials At The Best Price With Timely Delivery And Trusted Service.",
    image: "/assets/images/vendors/vendor1.png",
    verified: true,
  },
  {
    id: 17,
    name: "Vardhan Steel",
    location: "Bavdhan, Pune",
    material: "Steel",
    description:
      "Quality Building Materials At The Best Price With Timely Delivery And Trusted Service.",
    image: "/assets/images/vendors/vendor2.png",
    verified: true,
  },
  {
    id: 18,
    name: "Akash Plywoods",
    location: "Hadapsar, Pune",
    material: "Plywood",
    description:
      "Quality Building Materials At The Best Price With Timely Delivery And Trusted Service.",
    image: "/assets/images/vendors/vendor3.png",
    verified: true,
  },

  {
    id: 19,
    name: "Jay Hardware",
    location: "Katraj, Pune",
    material: "Hardware",
    description:
      "Quality Building Materials At The Best Price With Timely Delivery And Trusted Service.",
    image: "/assets/images/vendors/vendor1.png",
    verified: true,
  },
  {
    id: 20,
    name: "Vardhan Steel",
    location: "Bavdhan, Pune",
    material: "Steel",
    description:
      "Quality Building Materials At The Best Price With Timely Delivery And Trusted Service.",
    image: "/assets/images/vendors/vendor2.png",
    verified: true,
  },
  {
    id: 21,
    name: "Akash Plywoods",
    location: "Hadapsar, Pune",
    material: "Plywood",
    description:
      "Quality Building Materials At The Best Price With Timely Delivery And Trusted Service.",
    image: "/assets/images/vendors/vendor3.png",
    verified: true,
  },
  {
    id: 22,
    name: "Jay Hardware",
    location: "Katraj, Pune",
    material: "Hardware",
    description:
      "Quality Building Materials At The Best Price With Timely Delivery And Trusted Service.",
    image: "/assets/images/vendors/vendor1.png",
    verified: true,
  },
  {
    id: 23,
    name: "Vardhan Steel",
    location: "Bavdhan, Pune",
    material: "Steel",
    description:
      "Quality Building Materials At The Best Price With Timely Delivery And Trusted Service.",
    image: "/assets/images/vendors/vendor2.png",
    verified: true,
  },
  {
    id: 24,
    name: "Akash Plywoods",
    location: "Hadapsar, Pune",
    material: "Plywood",
    description:
      "Quality Building Materials At The Best Price With Timely Delivery And Trusted Service.",
    image: "/assets/images/vendors/vendor3.png",
    verified: true,
  },
  {
    id: 25,
    name: "Jay Hardware",
    location: "Katraj, Pune",
    material: "Hardware",
    description:
      "Quality Building Materials At The Best Price With Timely Delivery And Trusted Service.",
    image: "/assets/images/vendors/vendor1.png",
    verified: true,
  },
  {
    id: 26,
    name: "Vardhan Steel",
    location: "Bavdhan, Pune",
    material: "Steel",
    description:
      "Quality Building Materials At The Best Price With Timely Delivery And Trusted Service.",
    image: "/assets/images/vendors/vendor2.png",
    verified: true,
  },
  {
    id: 27,
    name: "Akash Plywoods",
    location: "Hadapsar, Pune",
    material: "Plywood",
    description:
      "Quality Building Materials At The Best Price With Timely Delivery And Trusted Service.",
    image: "/assets/images/vendors/vendor3.png",
    verified: true,
  },
  {
    id: 28,
    name: "Jay Hardware",
    location: "Katraj, Pune",
    material: "Hardware",
    description: "Quality Building Materials At The Best Price With Timely Delivery And Trusted Service.",
    image: "/assets/images/vendors/vendor1.png",
    verified: true,
  },

  {
    id: 29,
    name: "Jay Hardware",
    location: "Katraj, Pune",
    material: "Hardware",
    description:
      "Quality Building Materials At The Best Price With Timely Delivery And Trusted Service.",
    image: "/assets/images/vendors/vendor1.png",
    verified: true,
  },
  {
    id: 30,
    name: "Vardhan Steel",
    location: "Bavdhan, Pune",
    material: "Steel",
    description:
      "Quality Building Materials At The Best Price With Timely Delivery And Trusted Service.",
    image: "/assets/images/vendors/vendor2.png",
    verified: true,
  },
  {
    id: 31,
    name: "Akash Plywoods",
    location: "Hadapsar, Pune",
    material: "Plywood",
    description:
      "Quality Building Materials At The Best Price With Timely Delivery And Trusted Service.",
    image: "/assets/images/vendors/vendor3.png",
    verified: true,
  },
  {
    id: 32,
    name: "Jay Hardware",
    location: "Katraj, Pune",
    material: "Hardware",
    description:
      "Quality Building Materials At The Best Price With Timely Delivery And Trusted Service.",
    image: "/assets/images/vendors/vendor1.png",
    verified: true,
  },
  {
    id: 33,
    name: "Vardhan Steel",
    location: "Bavdhan, Pune",
    material: "Steel",
    description:
      "Quality Building Materials At The Best Price With Timely Delivery And Trusted Service.",
    image: "/assets/images/vendors/vendor2.png",
    verified: true,
  },
  {
    id: 34,
    name: "Akash Plywoods",
    location: "Hadapsar, Pune",
    material: "Plywood",
    description:
      "Quality Building Materials At The Best Price With Timely Delivery And Trusted Service.",
    image: "/assets/images/vendors/vendor3.png",
    verified: true,
  },
  {
    id: 35,
    name: "Jay Hardware",
    location: "Katraj, Pune",
    material: "Hardware",
    description:
      "Quality Building Materials At The Best Price With Timely Delivery And Trusted Service.",
    image: "/assets/images/vendors/vendor1.png",
    verified: true,
  },
  {
    id: 36,
    name: "Vardhan Steel",
    location: "Bavdhan, Pune",
    material: "Steel",
    description:
      "Quality Building Materials At The Best Price With Timely Delivery And Trusted Service.",
    image: "/assets/images/vendors/vendor2.png",
    verified: true,
  },
];

function Vendor() {
  const [showInquiry, setShowInquiry] = useState(false);
  const [showCall, setShowCall] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 9;

  const totalPages = Math.ceil(vendors.length / itemsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const paginatedData = vendors.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage,
  );

  return (
    <div className="container mt-4 vendor-section">
      <Common_Headings title="POPULAR VENDOR" />

      <div className="row">
        {paginatedData.map((vendor, index) => (
          <div
            key={`${vendor.id}-${index}`}
            className="col-12 col-sm-6 col-md-6 col-lg-4 mb-4"
          >
            <Common_Vendor_Card
              vendor={vendor}
              onClick={() => setShowInquiry(true)}
              onClick2={() => setShowCall(true)}
            />
          </div>
        ))}
      </div>
      <div className="row mt-4 mb-5">
        <Pagination_Holder
          onPageChange={currentPage}
          totalPages={totalPages}
          handlePageChange={handlePageChange}
        />
      </div>

      <Send_Button_Modal
        show={showInquiry}
        handleClose={() => setShowInquiry(false)}
      />
      <Call_Now_Modal show={showCall} handleClose={() => setShowCall(false)} />
    </div>
  );
}

export default Vendor;
